import { css } from '@sportnet/ui/lib/Themes/styled-components';
import { mb } from '@sportnet/ui/lib/Themes/utilities';
import { em } from 'polished';
import styled from '../../../theme/styled-components';

export const Page = styled('div')`
  flex: 1 1 auto;
  overflow: hidden;
  color: ${({ theme }) => theme.app.textColor};
  margin-bottom: auto;
`;

export const Center = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Title = styled('h1')<{ isCentered?: boolean }>`
  display: inline;
  vertical-align: middle;
  line-height: 1.25;
  font-size: ${em(36)};
  ${mb('m')} {
    font-size: ${em(44)};
  }
  color: ${({ theme }) => theme.title.textColor};
  margin: 0;
  padding: 0;
  font-weight: normal;
  word-break: break-word;
  ${({ isCentered }) =>
    isCentered &&
    css`
      text-align: center;
    `}
`;
